import {
  HiOutlineFolderOpen,
  HiOutlineBookOpen,
  // HiOutlineDocumentReport,
  HiOutlineOfficeBuilding,
  HiOutlinePresentationChartLine,
  HiOutlinePuzzle
} from 'react-icons/hi';
import { MenuItem } from '.';
import { pathnames } from 'routes/dacum';

const dacumMenu: MenuItem[] = [
  {
    name: 'Overview',
    url: pathnames.overview,
    icon: HiOutlinePresentationChartLine,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Competency Management',
    url: pathnames.competencyManagement,
    icon: HiOutlineBookOpen,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'School',
    url: '#',
    icon: HiOutlineOfficeBuilding,
    children: [
      {
        name: 'School Competency',
        url: pathnames.schoolManagement,
        role: ['superadmin']
      },
      {
        name: 'Job Family',
        url: pathnames.schoolJobFamily,
        role: ['superadmin']
      }
    ],
    role: ['superadmin']
  },
  {
    name: 'Module',
    url: '#',
    icon: HiOutlinePuzzle,
    children: [
      {
        name: 'Competency Module Management',
        url: pathnames.competencyModule,
        role: ['superadmin']
      },
      {
        name: 'Competency Module Job Family',
        url: pathnames.competencyModuleJobFamily,
        role: []
      }
    ],
    role: ['superadmin']
  },
  {
    name: 'Review Masterplan',
    url: pathnames.reviewMasterPlan,
    icon: HiOutlinePresentationChartLine,
    children: [],
    role: ['superadmin']
  },
  // {
  //   name: 'Report',
  //   url: pathnames.report,
  //   icon: HiOutlineDocumentReport,
  //   children: [],
  //   role: ['superadmin']
  // },
  {
    name: 'Master Data',
    url: '#',
    icon: HiOutlineFolderOpen,
    children: [
      {
        name: 'Admin User',
        url: pathnames.masterUserAdmin,
        role: ['superadmin']
      },
      {
        name: 'Area',
        url: pathnames.masterArea,
        role: ['superadmin']
      }
    ],
    role: ['superadmin']
  }
];

export const DACUM_MENU = dacumMenu;
